<template>
  <md-card>
    <md-divider></md-divider>
    <md-card-content>
      <md-table v-model="requirements" md-sort="id" md-sort-order="asc">
        <md-table-row slot="md-table-row" slot-scope="{ item, index }">
          <md-table-cell md-label="">
            {{ index + 1 }}. {{ item.text }}
          </md-table-cell>
          <md-table-cell
            md-label="Acciones"
            v-if="$can('change', 'Quantification', 'closeprojectvalidations')"
          >
            <md-checkbox v-model="payload[item.model]"></md-checkbox>
          </md-table-cell>
          <md-table-cell md-label="">
            <md-button
              class="md-just-icon md-info"
              @click="$emit('seeRequirementInfo', item.info)"
            >
              <md-icon>list</md-icon>
              <md-tooltip>{{ item.tooltip }}</md-tooltip>
            </md-button>
          </md-table-cell>
        </md-table-row>
      </md-table>
      <p class="hint-text">
        Seleccione todas las casillas para terminar con el proceso*
      </p>
    </md-card-content>
  </md-card>
</template>

<script>
export default {
  name: "RequirementsTable",
  props: {
    casualty: {
      type: [Object, null],
      required: false,
      default: () => {},
    },
    roadSinister: {
      type: [Object, null],
      required: false,
      default: () => {},
    },
    quantification: {
      type: [Object, null],
      required: false,
      default: () => {},
    },
    payload: {
      type: Object,
      required: true,
      default: () => {},
    },
  },
  // EDP GO GOF
  data() {
    return {
      requirements: [
        {
          text: "Se cumplen los procesos constructivos",
          tooltip: "Revisar fotos de proceso y terminado",
          model: "buildProcess",
          info: { fileTypes: ["process", "endend"], quantification: false },
        },
        {
          text: "La cantidad de materiales es correcta",
          tooltip:
            "Revisar listado de materiales con cantidades, archivos de generador de obra, daño, proceso y terminado",
          model: "materialsQuantity",
          info: {
            fileTypes: ["damage", "process", "endend", "GOD"],
            quantification: true,
          },
        },
        {
          text: "El personal cumplió con el equipo de seguridad, uniformes y enconado",
          tooltip:
            "Revisar fotos de seguridad (uniformes de trabajo y dispositivos, retiro de señalamiento y dispositivos, levantamiento, conos instalados y aguja)",
          model: "securityTools",
          info: { fileTypes: ["security"], quantification: false },
        },
        {
          text: "Los rendimientos fueron de acuerdo al proyecto",
          tooltip: "Revisar cuantificación",
          model: "projectYield",
          info: { fileTypes: [], quantification: true },
        },
        {
          text: "El salvamento coincide con lo marcado en el generador de obra",
          tooltip:
            "Revisar archivos de generador de obra y fotos de salvamento y resguardo",
          model: "rescueMatches",
          info: {
            fileTypes: ["GOD", "RETSAL", "ALMSAL", "BTCF", "GOF"],
            quantification: false,
          },
        },
      ],
    };
  },
};
</script>

<style lang="less" scoped>
.md-checkbox {
  margin: 0;
}
.md-tooltip {
  word-wrap: break-word;
}
.md-table {
  min-height: 360px;
}
.hint-text {
  color: #ffb326;
}
</style>



// WEBPACK FOOTER //
// src/pages/RoadSinisters/CloseProject/requirementsTable.vue